import { useRouteMatch } from "react-router-dom";
import { EventPage } from "./EventPage";
import { useAuth, useGreeterGuestApi } from "@greeter/matter";
import Routes, { TicketEventRouteParams } from "@greeter-guest/utility/Routes";
import { useEffect } from "react";

export function EventPageApiHandler() {
  const match = useRouteMatch<TicketEventRouteParams>(
    Routes.ticketEvent.template()
  );
  const { api } = useGreeterGuestApi();
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isLoggedIn) auth.auth?.signInAsAnon();
  }, [auth]);

  return <EventPage slug={match?.params.slug ?? ""} api={api} />;
}

export default EventPageApiHandler;
